<template>
	<v-container style="padding: 0;">
		<v-dialog title="班级详情页" v-model="hideShow" width="1200px" persistent>
			<v-card>
				<v-card-title>
					<span>班级详情信息</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel" color="error">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-tabs background-color="teal lighten-3" center-active dark v-model="tab"
						style="border-radius: 5px 5px 0 0;" active-class="child_active">
						<v-tabs-slider color="teal darken-3"></v-tabs-slider>
						<v-tab>班级信息</v-tab>
						<v-tab>排课明细</v-tab>
					</v-tabs>
					<v-tabs-items v-model="tab">
						<v-tab-item>
							<v-card min-height="600" class="elevation-4 mb-6" style="border: solid #eee 1px;">
								<v-card-text v-if="classModel">
									
									<v-row class="pl-10">
										<v-col cols="5" class="mt-2">
											<div class="d-flex">
												<span class="text-h6">班级名称：</span>
												<span style="font-size: 16px; font-weight: 500;" class="mt-1">{{classModel.className}}</span>
												<v-btn color="info" small @click="showUpdateClass" class="ml-2">修改班级</v-btn>
											</div>
											<div class="mt-4">
												<span>课程名称：{{classModel.courseName}}</span>
												<span class="ml-1">({{ consumeTypeName(classModel.consumeType) }})</span>
												<v-btn v-if="classModel.consumeType=='2'" @click="showUpgradeView" small color="info" class="ml-1 mt-n1">升班</v-btn>
											</div>
											
											<div class="mt-4 d-flex">
												<span>教室：</span>
												<span>{{classModel.roomName}}</span>
												<span class="ml-2">主课老师：{{classModel.teacherName}}</span>
												<v-btn @click="showUpdateTeacher" :disabled="classModel.status !== '1'" small color="info" class="ml-1 mt-n1">修改老师</v-btn>	
											</div>
											
											
											
											<div class="mt-4">
												<template v-if="classModel.secondTeacherName">
													<span>助教老师一：</span>
													<span>{{classModel.secondTeacherName}}</span>
												</template>
												<template v-if="classModel.thirdTeacherName">
													<span class="ml-3">助教老师二：</span>
													<span>{{classModel.thirdTeacherName}}</span>
												</template>
											</div>
											<div class="mt-4">
												<span>满班人数：</span>
												<span>{{classModel.maxQty}}</span>
												<span class="ml-3">现有人数：</span>
												<span>{{classModel.studentQty}}</span>
												<span class="ml-3">每节课扣：</span>
												<span>{{classModel.reduceQty}}课时</span>
											</div>
											<div class="mt-4 d-flex">
												<span>记老师绩效节数：</span>
												<span>{{classModel.addTeacherClassCount}}</span>
												<span class="ml-3">状态：</span>
												<span v-if="classModel.status=='1'">正常</span>
												<span v-if="classModel.status=='0'" style="color: red;">已作废</span>
												<v-btn @click="frozenClass" v-if="classModel.status == '1'" color="error" class="ml-1 mt-n1" small>作废班级</v-btn>
												<v-btn @click="freeClass" v-if="classModel.status == '0'" color="info" class="ml-1 mt-n1" small>启用</v-btn>
													
											</div>
											<div class="mt-4">
												<span>总课次数：</span>
												<span>{{classModel.totalTimes}}</span>
												<span class="ml-3">已上课次数：</span>
												<span>{{classModel.approvedTimes}}</span>
												<span class="ml-3">剩余课次：{{balanceTimes}}</span>
											</div>
											<div class="mt-4">
												<span>自动送积分：</span>
												<span v-if="classModel.autoPoint=='1'" style="color: #039BE5; font-weight: 500;">开启中</span>
												<span v-if="classModel.autoPoint=='1'" style="color: #039BE5; font-weight: 500;">({{classModel.autoPointQty}}积分/课次)</span>
												<span v-if="classModel.autoPoint=='0'">未开启</span>
												<v-btn v-if="classModel.autoPoint=='0'" @click="openAutoPoint" color="info" class="ml-2 mt-n1" small>开启</v-btn>
												<v-btn v-if="classModel.autoPoint=='1'" @click="closeAutoPoint" color="info" class="ml-2 mt-n1" small>关闭</v-btn>
											</div>
											<div class="mt-4">
												<span>开课日期：</span>
												<span>{{classModel.dateFrom}}</span>
												<span class="ml-3">结束日期：</span>
												<span>{{classModel.dateTo}}</span>
											</div>
											<div class="mt-4 d-flex flex-wrap" style="height: 70px;" >
												<span>上课时间：</span>
												
												
												<div v-for="(plan,idx) in classModel.timePlanList" :key="idx" class="mr-2 mb-1"
													style="width: 115px; height: 25px; line-height: 25px; border-bottom: solid #B388FF 2px; border-radius: 5px; text-align: center;">
													<span>{{plan.weekName}}</span>
													<span class="ml-1">{{plan.timeFrom}}-{{plan.timeTo}}</span>
												</div>
												<v-btn color="info" @click="showUpdateTime" class="ml-1" small>修改时间</v-btn>
											</div>
											
											<!-- 添加学员 -->
											<div class="mt-3 pa-2 mr-5" style="background-color: #f5f5f5; border-radius: 10px; height: 130px;">
												
												<div class="ml-2 mt-1"><span style="font-weight: 500;">给班级添加新学员：</span></div>
												<div class="d-flex flex-wrap mt-1 ml-2">
													<div style="width: 130px;">
														<v-autocomplete :items="notInClassStudentList" v-model="addStudent.studentId"
															item-text="studentName" item-value="id" label="选择学员" dense outlined
															no-data-text="暂无学员"></v-autocomplete>
													</div>
													<div v-if="classModel&&classModel.consumeType=='2'" class="ml-2" style="width: 100px;">
														<v-text-field v-model="addStudent.consumePrice" label="课时价格" dense
															outlined></v-text-field>
													</div>
													<div style="width: 130px;" class="ml-2">
														<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
															transition="scale-transition" offset-y min-width="auto">
															<template v-slot:activator="{ on, attrs }">
																<v-text-field v-model="addStudent.joinDate" label="进班日期" readonly v-bind="attrs" v-on="on"
																	dense outlined></v-text-field>
															</template>
															<v-date-picker v-model="addStudent.joinDate" @input="menu1=false" no-title scrollable locale="zh-cn">
															</v-date-picker>
														</v-menu>
													</div>
												</div>
												<div class="mt-n5">
													<v-btn @click="addToClass" color="info" small class="ml-3 mt-1">加入班级</v-btn>
												</div>
											
											</div>
										</v-col>
										<v-col cols="7">
											<div class="d-flex flex-column align-center mr-5">
												<div class="d-flex">
													<span class="text-h6">班级正常学员</span>
													<span style="color:blueviolet;font-size:14px;font-weight: 500;" class="mt-1">
														({{normalStudentList.length}}人)
													</span>
												</div>
												<div style="background-color: #eeeeee; height: 2px;width: 100%" class="mt-n1"></div>
											</div>
											<!-- 学员列表 -->
											<div class="ml-3" style="max-height: 500px;overflow-y: auto;">
												<div class="d-flex flex-wrap">
													<!-- 正常学员列表 -->
													<div v-for="(item,index) in normalStudentList" :key="index" class="d-flex mt-3 mr-3">
														<div style="height: 80px; width: 10px; border-radius: 10px 0 0 10px; background-color: #B2EBF2;"></div>
														<div class="d-flex flex-column justify-center" style="background: #F5F5F5; width: 270px; border-radius: 0 10px 10px 0;">
															<div class="d-flex align-center"  style="cursor: pointer;"  @click="toShowStudentDetail(item)">
																<v-avatar size="60" class="ml-2">
																	<v-img v-if="item.studentAvatar" :src="imgPrev + item.studentAvatar" @click.stop="showImageViewer(item.studentAvatar)" ></v-img>
																</v-avatar>
																<!-- 名字 -->
																<div class="d-flex flex-column ml-2" style="width: 70%;">
																	<div class="ml-2 mt-1 d-flex" style="color: black; ">
																		<span>{{item.studentName}}</span>
																		<v-spacer></v-spacer>
																		<v-icon color="error" style="cursor: pointer;" @click.stop="frozenClassStudent(item)">mdi-account-off</v-icon>
																	</div>
																	<!-- 价格 -->
																	<div class="d-flex ml-2 "  v-if="item.consumeType=='2'">
																		<span>消课价格：</span>
																		<span class="mb-1">
																			{{item.classPrice}}元/课时
																		</span>
																	</div>
																	<!-- 进班日期 -->
																	<div class="d-flex ml-2">
																		<span>进班日期：</span>
																		<span class="mb-1">
																			{{item.joinDate}}
																		</span>	
																	</div>
																						
																</div>
															</div>
															
														</div>
													</div>
													<div v-if="normalStudentList.length == 0" class="mt-5">
														<span>班级暂无正式学员</span>
													</div>
												</div>
												<div class="mt-5 d-flex" v-if="frozenStudentList.length > 0">
													<v-divider></v-divider>
													<span class="mt-n2 ml-1 mr-1">以下为禁用学员</span>
													<v-divider></v-divider>
												</div>
												
												<div class="d-flex flex-wrap mb-3">
													<!-- 禁用学员列表 -->
													<div v-for="(item,index) in frozenStudentList" :key="index" class="d-flex mt-3 mr-3">
														<div style="height: 80px; width: 10px; border-radius: 10px 0 0 10px; background-color: #EF5350;"></div>
														<div class="d-flex flex-column justify-center" style="background: #F5F5F5; width: 270px; border-radius: 0 10px 10px 0;">
															<div class="d-flex align-center" style="cursor: pointer;"  @click="toShowStudentDetail(item)">
																<v-avatar size="60" class="ml-2" >
																	<v-img v-if="item.studentAvatar" :src="imgPrev + item.studentAvatar" @click.stop="showImageViewer(item.studentAvatar)"></v-img>
																</v-avatar>
																<!-- 名字 -->
																<div class="d-flex flex-column ml-2" style="width: 68%;">
																	<div class="ml-2 mt-1 d-flex" style="color: black;">
																		<span>{{item.studentName}}</span>
																		<v-spacer></v-spacer>
																		<v-icon color="success" style="cursor: pointer;" @click.stop="freeClassStudent(item)">mdi-account-plus</v-icon>
																	</div>
																	<!-- 价格 -->
																	<div class="d-flex ml-2 "  v-if="item.consumeType=='2'">
																		<span>消课价格：</span>
																		<span class="mb-1">
																			{{item.classPrice}}元/课时
																		</span>
																	</div>
																	<!-- 进班日期 -->
																	<div class="d-flex ml-2">
																		<span>进班日期：</span>
																		<span class="mb-1">
																			{{item.joinDate}}
																		</span>	
																	</div>
																						
																</div>
															</div>
															
														</div>
													</div>
												</div>
												
											</div>
											
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
						</v-tab-item>
						
						<!-- 排课明细 -->
						<v-tab-item>
							<div style="min-height: 600px;">
								<!-- 班级排课明细组件 -->
								<classRecordList :classId="recordList.classId" @dataChanged="getClassDetail">
								</classRecordList>
							</div>
							
						</v-tab-item>
					</v-tabs-items>
				</v-card-text>
			</v-card>


		</v-dialog>


		<!-- 修改班级dialog -->
		<v-dialog title="修改班级" v-model="updateClass.dialog" max-width="500" persistent>
			<v-card>
				<v-card-title>
					<span>修改班级信息</span>
					<v-spacer></v-spacer>
					<v-icon @click="updateClass.dialog=false">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="6">
							<v-text-field label="班级名称" v-model="updateClass.className" dense outlined></v-text-field>
						</v-col>

						<v-col cols="6">
							<v-text-field label="最大学生人数" type="number" v-model="updateClass.maxQty" dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="每节课扣课时" type="number" v-model="updateClass.reduceQty" dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="6" class="d-flex">
							<v-select :items="selectRoomList" v-model="updateClass.roomId" item-text="roomName"
								item-value="id" label="上课教室" dense outlined></v-select>
						</v-col>
						<v-col cols="6" class="d-flex">
							<v-select :items="selectTeacherList" v-model="updateClass.secondTeacherId" item-text="trueName"
								item-value="id" label="助教老师一" dense outlined clearable></v-select>
						</v-col>
						<v-col cols="6" class="d-flex">
							<v-select :items="selectTeacherList" v-model="updateClass.thirdTeacherId" item-text="trueName"
								item-value="id" label="助教老师二" dense outlined clearable></v-select>
							
						</v-col>
						<v-col cols="6">
							<v-text-field label="每次课记老师绩效课节数" type="number" v-model="updateClass.addTeacherClassCount" dense outlined>
							</v-text-field>
						</v-col>

					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="updateClass.dialog=false">取消</v-btn>
					<v-btn @click="submitUpdateClass" color="info">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- 修改老师dialog -->
		<v-dialog title="修改主课老师" v-model="updateTeacher.dialog" max-width="500" persistent>
			<v-card>
				
				<v-card-title>
					<span>修改主课老师</span>
					<v-spacer></v-spacer>
					<v-icon @click="updateTeacher.dialog=false">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="12">
							<v-select :items="selectTeacherList" v-model="updateTeacher.oldTeacherId"
								item-text="trueName" item-value="id" label="原老师" disabled dense outlined></v-select>
						</v-col>
						<v-col cols="12">
							<v-select :items="selectTeacherList" v-model="updateTeacher.newTeacherId"
								item-text="trueName" item-value="id" label="新老师" dense outlined></v-select>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="updateTeacher.dialog=false">取消</v-btn>
					<v-btn @click="submitUpdateTeacher" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- 开启自动积分 dialog -->
		<v-dialog title="开启自动积分" v-model="autoPointDialog.show" max-width="500" persistent>
			<v-card>
				
				<v-card-title>
					<span>开启自动积分</span>
					<v-spacer></v-spacer>
					<v-icon @click="autoPointDialog.show=false">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="12">
							<v-text-field label="每课次每人积分数" type="number" v-model="autoPointDialog.autoPointQty" dense outlined>
							</v-text-field>
						</v-col>
						
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="autoPointDialog.show=false">取消</v-btn>
					<v-btn @click="submitOpenAutoPoint" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		
		<!-- 修改排课时间 -->
		<updateClassTime :show="updateTime.show" :classModel="updateTime.classModel" @cancel="updateTime.show=false"
			@success="classTimeUpdated"></updateClassTime>
		
		
		<!-- 班级成员详情 -->
		<classStudentDetail :show="classStudentView.show" :classStudent="classStudentView.classStudent" @cancel="classStudentView.show=false" 
			 @leave="studentLeavedClass"></classStudentDetail>
	
		<!-- 升班 -->
		<classUpgrade :show="classUpgradeView.show" :classModel="classUpgradeView.classModel" @cancel="classUpgradeView.show=false"
			@success="classUpgradeSuccess"></classUpgrade>
			
		<!-- 图片预览 -->
		<imageViewer :show="imageViewerDialog.show" :imgSrc="imageViewerDialog.imgSrc" imgWidth="400" imgHeight="400" @cancel="imageViewerDialog.show=false"></imageViewer>
	
	</v-container>
</template>

<script>
	import utils from "../config/utils"
	
	import classRecordList from "./class_record_list.vue"
	import updateClassTime from "./update_class_time.vue"
	import classStudentDetail from "./class_student_detail.vue"
	import classUpgrade from "./class_upgrade.vue"
	import imageViewer from "./image_viewer.vue"
	export default {
		name: "class-detail",
		components: {
			classRecordList,
			updateClassTime,
			classStudentDetail,
			classUpgrade,
			imageViewer
		},
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			classId: {
				type: String,
				default: ""
			}
		},
		watch: {
			show(newVal, oldVal) {
				console.log("newVal", newVal);
				this.hideShow = newVal;
				if (this.hideShow) {
					this.tab = 0;

					this.classModel = null;
					this.getClassDetail();
					this.recordList.classId = this.classId;
					
					this.addStudent.joinDate = utils.getNowDate();

					this.getClassAllStudentList();
					this.getStudentListForSelect();

				}
			}
		},
		computed: {
			balanceTimes() {
				let result = "";
				if (this.classModel) {
					let balance = parseInt(this.classModel.totalTimes) - parseInt(this.classModel.approvedTimes);
					result = balance.toString()
				}
				return result;
			},
			notInClassStudentList(){
				// 选择学员 剔除已在班级的
				let list = [];
				
				this.selectStudentList.forEach((item,index)=>{
					
					let isOK = true;
					
					this.normalStudentList.forEach((item1,index1)=>{
						if (item.id == item1.studentId){
							isOK = false;
						}
					})
					
					if (isOK){
						list.push(item);
					}
					
				})
				
				return list;
				
			}
		},
		data() {
			return {
				menu1:false,
				tab: null,
				imgPrev: "https://photo.youkeya.cn/",
				hideShow: this.show,
				classModel: null,
				studentList: [], //班级学员列表
				normalStudentList: [], //正常学员
				frozenStudentList:[],  //禁用学员
				selectStudentList: [], // 选择学员
				selectTeacherList: [],
				selectRoomList:[], // 上课教室
				addStudent: {
					studentId: "",
					consumePrice: "",
					joinDate:""
				},
				recordList: {
					classId: ""
				},
				updateClass: {
					dialog: false,
					id: "",
					className: "",
					maxQty: "",
					courseId: "",
					roomId:"",
					reduceQty:"",
					addTeacherClassCount:""
				},
				updateTime: {
					show: false,
					classModel: null
				},
				updateTeacher: {
					dialog: false,
					classId: "",
					oldTeacherId: "",
					newTeacherId: "",
					secondTeacherId:"",
					thirdTeacherId:""
				},
				classStudentView:{
					show:false,
					classStudent:null
				},
				classUpgradeView:{
					show:false,
					classModel:null
				},
				autoPointDialog:{
					show:false,
					autoPointQty:"0"
				},
				imageViewerDialog:{
					show:false,
					imgSrc:"",
				},
				
			}
		},
		mounted() {
			console.log("class-detail mounted");
		},
		methods: {
			cancel() {
				this.$emit("cancel", "");
			},
			consumeTypeName(state) {
				let stName = "未知";
				if (state === "1") {
					stName = "按课时扣费";
				} else if (state === "2") {
					stName = "按金额扣费";
				}
				return stName;
			},
			consumeTypeColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "2") {
					color = "warning";
				}
				return color;
			},
			openAutoPoint(){
				// 开启自动积分
				this.autoPointDialog.autoPointQty = this.classModel.autoPointQty;
				this.autoPointDialog.show= true;
				
			},
			submitOpenAutoPoint(){
				const that = this;
				let url = `/edu/class/open/auto/point`;
				
				if (!this.autoPointDialog.autoPointQty){
					this.$noty.error("请输入自动积分数");
					return
				}
				if(parseInt(this.autoPointDialog.autoPointQty)<1){
					this.$noty.error("积分数不能少于1");
					return
				}
				
				let postData = {
					classId:this.classId,
					autoPointQty: this.autoPointDialog.autoPointQty
				}
				
				this.axios.post(url,postData).then(response => {
				
					if (response.data["code"] === 200) {
				
						that.$noty.success("开启成功");
						that.classModel.autoPoint  = "1";
						that.classModel.autoPointQty  = that.autoPointDialog.autoPointQty;
						that.autoPointDialog.show = false;
					
						return
					} else {
						that.$noty.error("获取失败：" + response.data["message"]);
					}
				})
			},
			closeAutoPoint(){
				// 关闭自动积分
				const that = this;
				let url = `/edu/class/close/auto/point/${this.classId}`;
				
				this.axios.post(url).then(response => {
				
					if (response.data["code"] === 200) {

						that.$noty.success("关闭成功");
						that.classModel.autoPoint  = "0";
	
						return
					} else {
						that.$noty.error("获取失败：" + response.data["message"]);
					}
				})
				
			},
			getClassDetail() {
				console.log("获取班级详情");

				const that = this;
				let url = `/edu/class/detail/${this.classId}`;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {

						console.log(">>>>>>>>> 获取班级基本信息 start>>>>>>>>>")

						console.log("url:", url);
						console.log("res:", response.data);

						console.log(">>>>>>>>> 获取班级基本信息 end>>>>>>>>>")

						that.classModel = response.data["data"] ? response.data["data"] : [];

						that.addStudent.consumePrice = that.classModel.consumePrice;
						return
					} else {
						that.$noty.error("获取失败：" + response.data["message"]);
					}
				})
			},
			addToClass() {
				// 给班级添加学员
				if (!this.addStudent.studentId) {
					this.$noty.error("请选择学员");
					return
				}
				
				if (!this.addStudent.joinDate) {
					this.$noty.error("请选择进班日期");
					return
				}
				

				// 如果是扣学费的 要填写单价
				if (this.classModel.consumeType == '2') {
					if (!this.addStudent.consumePrice) {
						this.$noty.error("请输入课时单价");
						return
					}
				}


				if (parseInt(this.classModel.studentQty) >= parseInt(this.classModel.maxQty)) {
					this.$noty.error("班级已满");
					return
				}

				// 提交api
				// api
				const that = this;
				let url = `/edu/class/student/create`;
				let postData = {
					shopId: this.classModel.shopId,
					classId: this.classModel.id,
					studentId: this.addStudent.studentId,
					consumePrice: this.addStudent.consumePrice,
					joinDate:this.addStudent.joinDate
				};

				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");

							// 提交成功
							that.addStudent.studentId = "";
							that.addStudent.consumePrice = that.classModel.consumePrice;

							//重新加载班级学员
							that.getClassAllStudentList();

							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});
			},
			showUpdateTime() {
				this.updateTime.classModel = this.classModel;
				this.updateTime.show = true;
			},
			classTimeUpdated() {
				this.updateTime.show = false;
				this.getClassDetail();
			},
			showUpdateTeacher() {
				this.updateTeacher.dialog = true;
				this.updateTeacher.classId = this.classModel.id;
				this.updateTeacher.oldTeacherId = this.classModel.teacher;


				this.getTeacherListForSelect();
			},
			showUpdateClass() {
				this.updateClass.dialog = true;
				this.updateClass.id = this.classModel.id;
				this.updateClass.className = this.classModel.className;
				this.updateClass.maxQty = this.classModel.maxQty;
				this.updateClass.courseId = this.classModel.courseId;
				this.updateClass.secondTeacherId = this.classModel.secondTeacherId;
				this.updateClass.thirdTeacherId = this.classModel.thirdTeacherId;
				this.updateClass.roomId = this.classModel.roomId;
				this.updateClass.reduceQty = this.classModel.reduceQty;
				this.updateClass.addTeacherClassCount = this.classModel.addTeacherClassCount;
				
				this.getTeacherListForSelect();
				
				this.getRoomListForSelect();

			},
			toShowStudentDetail(item){
				console.log(item);
				this.classStudentView.classStudent = item;
				this.classStudentView.show=true;
			},
			submitUpdateClass() {

				if (!this.updateClass.className) {
					this.$noty.error('班级名称不能为空');
					return
				}
				if (!this.updateClass.maxQty) {
					this.$noty.error('班级人数不能为空');
					return
				}
				if (!this.updateClass.roomId) {
					this.$noty.error('教室不能为空');
					return
				}
				if (!this.updateClass.reduceQty) {
					this.$noty.error('扣课时数不能为空');
					return
				}
				if (!utils.isInt(this.updateClass.reduceQty)){
					this.$noty.error('扣课时数格式错误');
					return
				}
				
				if (!this.updateClass.addTeacherClassCount) {
					this.$noty.error('记老师绩效节数不能为空');
					return
				}
				if (!utils.isInt(this.updateClass.addTeacherClassCount)){
					this.$noty.error('记老师绩效节数格式错误');
					return
				}
				
				// 选择了助教一
				if (this.updateClass.secondTeacherId && this.updateClass.secondTeacherId != '0') {
					if (this.updateClass.secondTeacherId == this.classModel.teacher){
						this.$noty.error('助教老师一不能和主课老师相同');
						return
					}
				}
				
				//选择了助教二
				if (this.updateClass.thirdTeacherId && this.updateClass.thirdTeacherId != '0') {
					if (!this.updateClass.secondTeacherId) {
						this.$noty.error('请先选择助教老师一');
						return
					}
					
					if (this.updateClass.thirdTeacherId == this.classModel.teacher){
						this.$noty.error('助教老师二不能和主课老师相同');
						return
					}
					
					if (this.updateClass.thirdTeacherId == this.updateClass.secondTeacherId){
						this.$noty.error('助教老师二不能和助教老师一相同');
						return
					}
				}
				
				
				// api
				const that = this;
				let url = `/edu/class/update`;

				const updateData = {
					...this.updateClass
				}

				this.axios.post(url, updateData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.updateClass.dialog = false;

							this.getClassDetail();
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});
			},
			showUpgradeView(){
				// 显示升班控件
				this.classUpgradeView.classModel = this.classModel;
				this.classUpgradeView.show = true;
				
			},
			classUpgradeSuccess(){
				this.getClassDetail();
				this.getClassAllStudentList();
				this.classUpgradeView.show = false;
				
			},
			showImageViewer(imgSrc){
				this.imageViewerDialog.imgSrc = imgSrc;
				console.log(imgSrc);
				this.imageViewerDialog.show=true;
			},
			submitUpdateTeacher() {
				//  修改班级老师
				if (!this.updateTeacher.classId) {
					this.$noty.error('班级ID不能为空');
					return
				}
				if (!this.updateTeacher.newTeacherId) {
					this.$noty.error('新的老师不能为空');
					return
				}
				
				if (this.updateTeacher.newTeacherId == this.classModel.teacher){
					this.$noty.error('新的老师不能和原老师相同');
					return
				}

				// api
				const that = this;
				let url = `/edu/class/teacher/update`;

				// parameters
				const updateData = {
					classId: this.updateTeacher.classId,
					newTeacherId: this.updateTeacher.newTeacherId
				}

				this.axios.post(url, updateData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.updateTeacher.dialog = false;
							that.getClassDetail();

							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});
			},
			frozenClass() {
				//冻结
				const that = this;
				let url = `/edu/class/frozen/${this.classId}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getClassDetail();
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}

				});
			},
			freeClass() {
				//冻结
				const that = this;
				let url = `/edu/class/free/${this.classId}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getClassDetail();
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}

				});
			},
			studentLeavedClass(){
				// 学员退班
				this.classStudentView.show = false;
				this.getClassDetail();
				this.getClassAllStudentList();
			},
			frozenClassStudent(item){
				// 禁用
				const that = this;
				let url = `/edu/class/student/frozen/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("禁用班级学员成功");
							that.getClassDetail();
							that.getClassAllStudentList();
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
							
				});
				
				
			},
			freeClassStudent(item){
				// 启用 班级学员
				const that = this;
				let url = `/edu/class/student/free/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("启用班级学员成功");
							that.getClassDetail();
							that.getClassAllStudentList();
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
				this.getClassDetail();
				this.getClassAllStudentList();
			},
			
			getTeacherListForSelect() {

				const shopId = utils.getCurrentShopId();
				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/teacher/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectTeacherList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getClassAllStudentList() {

				const classId = this.classId;
				// 获取班级学生列表
				if (!classId) {
					return
				}

				const that = this;
				let url = `/edu/class/student/list/` + classId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.studentList = response.data["data"] ? response.data["data"] : [];

						that.normalStudentList = [];
						that.frozenStudentList = [];
						that.studentList.forEach((item, index) => {
							if (item.status == '1') {
								that.normalStudentList.push(item);
							}else if (item.status =='0'){
								that.frozenStudentList.push(item);
							}
						})

						return
					} else {
						that.$noty.error("获取失败32：" + response.data["message"]);
					}


				})
			},
			getStudentListForSelect() {

				const shopId = utils.getCurrentShopId();
				// 获取校区学生列表
				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/student/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectStudentList = response.data["data"] ? response.data["data"] : [];
						return
					} else {
						that.$noty.error("获取失败55：" + response.data["message"]);
					}


				})
			},
			getRoomListForSelect() {
			
				const shopId = utils.getCurrentShopId();
				// 获取校区学生列表
				if (!shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/classroom/list/` + shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.selectRoomList = response.data["data"] ? response.data["data"] : [];
						return
					} else {
						that.$noty.error("获取失败55：" + response.data["message"]);
					}
			
			
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.child_active {
		background-color: #26A69A;
		border-radius: 5px 5px 0 0;

		&:hover {}
	}
</style>
